/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/30
 */
import React from 'react';

const Dots = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-dots">
    <path d="M804.571429 585.142857a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714z m-292.571429 0a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714zM219.428571 585.142857a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714z"/>
  </svg>
};

export default Dots;



// WEBPACK FOOTER //
// ./src/svgs/dots.js